import {
  Grid,
  GridProps,
  Stack,
  StackProps,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ElementType } from "react";
import { OverlayStack } from "../../components/CtaCommunityOverlay/CtaCommunityOverlay.styles";

type IHeroBanneContainer = {
  videoVisible: boolean,
  isActive: boolean,
  isMobile: boolean,
  isTablet: boolean,
  isMedium: boolean,
  coverPublicURL: string
}
export const HeroBannerContainer = styled(Stack)<StackProps & IHeroBanneContainer>(({ 
  theme, 
  coverPublicURL,
  isActive,
  isMobile,
  isTablet
}) => ({
  background:
   coverPublicURL
     ? `url(${coverPublicURL})`
     : theme.customColors.backgroundPrimary,
  backgroundPosition: "center",
  backgroundRepeat:"no-repeat",
  backgroundSize: "cover",
  borderBottom: `0.125rem solid ${theme.customColors.border}`,
  minHeight: "27.5rem",
  position:"relative",
  overflow: "hidden",
  transition: "all 0.35s ease-out",
  "& #snackBarFavourite": {
    top: !isMobile ? "0" : "-2.25rem",
    left: !isMobile ? "3rem" : "-2.25rem"
  },
  "& .box_collapse": {
    minHeight: "1.5rem",
    height: "1.5rem",
    opacity: 0,
    width: "100%",
    transition: "all 0.35s linear"
  },
  "& .collapse_cta": {
    opacity: 0,
    height: "0rem",
    transition: "all 0.35s ease" 
  },
  "& #hero-banner-breadcrumbs": {
    opacity: 0,
    top: "1.5rem",
    transition: "all 0.35s  linear",
    "&.active":{
      opacity: 1,
      top: "1.5rem",
      transition: "all 0.35s linear"
    }
  },
  "& #cta-overlay": {
    opacity: 0,
    transition: "all 0.35s ease" 
  },
  ...((isActive || isTablet) && {
    transition: "opacity 0.35s linear",
    "& .lo_tag_list, .hidden": {
      opacity: 1,
      height: "unset",
      marginBottom: "0.75rem"
    },
    "& .box_collapse": {
      minHeight: "3rem",
      height: "fit-content",
      width: "100%",
      opacity: 1
    },
    "& .herobanner-badges": {
      opacity: 1,
      height: "unset",
      top: "4rem"
    },
    "& .collapse_cta": {
      opacity: 1,
      height: "3.5rem",
      transition: "all 0.35s linear"
    },
    "& .herobanner-info": {
      gap: "1rem"
    },
    "& #hero-banner-breadcrumbs": {
      opacity: 1,
      top: "1.5rem",
      transition: "all 0.35s ease" 
    },
    "& #cta-overlay": {
      opacity: 1 ,
      transition: "all 0.35s ease" 
    }
  }),
  "&:focus-within": {
    "& #cta-overlay": {
      opacity: 1 ,
      transition: "all 0.35s ease" 
    },
    "& #hero-banner-breadcrumbs": {
      opacity: 1,
      transition: "all 0.35s ease" 
    },
    "& .box_collapse": {
      height: "fit-content",
      minHeight: "3rem",
      width: "100%",
      opacity: 1
    },
    "& .collapse_cta": {
      height: "3.5rem",
      opacity: 1,
      transition: "all 0.35s linear"
    },
    "& .herobanner-badges": {
      height: "unset",
      opacity: 1,
      top: "4rem"
    },
    "& .herobanner-info": {
      gap: "1rem"
    },
    "& .herobanner-mask": {
      transform: "translateX(-50%) rotate(90deg)",
      transition: "all 0.35s ease" 
    },
    "& .lo_tag_list, .hidden": {
      height: "unset",
      marginBottom: "0.75rem",
      opacity: 1
    },
    transition: "opacity 0.35s linear"
  }
}));

// Wrapper dei blocchi Darkfill e HeroBannerMask gestisce la rotazione
export const MaskWrapper = styled("div")<{ isActive: boolean, isTablet: boolean }>(({ isActive, isTablet }) => ({
  position: "absolute",
  top: "-80%",
  left: 0,
  width: isActive ? "110%" : "95vh",
  height: "400vh",
  zIndex: 2,
  transformOrigin: "5% 20%",
  transform: isActive ? "rotate(0deg)" : "rotate(-90deg)",
  transition: "all .3s ease-in-out",
  ...((isTablet) && {
    width: "95vh",
    height: "380vh",
    transform: "rotate(-90deg)"
  })
}));

// contenitore del gradiente
export const HeroBannerMask = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: "34.5%",     
  width: "20%",     
  height: "100%",
  background: `linear-gradient(to left, rgba(${theme.customColors.gradient05Start}) 35%, rgba(${theme.customColors.gradient05End}) 95%)`
}));

// blocco di appoggio per fillare il background dell herobanner
export const DarkFill = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: "-95%",
  width: "130%",    
  height: "100%",
  background: theme.customColors.backgroundCard
}));

export const HeroBannerMaskBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  top:0,
  left: "-100%",
  width: "40%",
  height: "100%",
  zIndex: 2,
  background: `linear-gradient(to left, transparent, ${theme.customColors.backgroundCard} 50%)`,
  transition: "all 0.35s ease-out"
}));

export const HeroBannerInfo= styled(Stack)<
  & StackProps 
  & { $isTablet: boolean }
  & {
    component: ElementType } // monkeypatch to fix property 'component' does not exist on type 'intrinsicattributes'
>(({ theme, $isTablet }) => ({
  justifyContent: "flex-end",
  minHeight: "fit-content",
  padding: !$isTablet ? "4.5rem 2.5rem 0rem" : "4.5rem 1rem 0rem",
  width: "100%",
  gap: "0rem",
  flexGrow: 1,
  zIndex: 3,
  ".status-box": {
    left:"-42px",
    marginBottom:"42px",
    position:"relative",
    top:"50",

    height:"60px",
    width:"60px"

  },

  "& .MuiChip-root": {
    border: `2.925px solid ${theme.customColors.borderTag}`,
    borderRadius: "0.4875rem",

    "& span": {
      fontSize: "1.125rem",
      fontWeight: "700",
      letterSpacing: "1.95px",
      lineHeight: "0.9375rem"
    }
  },

  [theme.breakpoints.down("sm")]: {
    //background: `url(${coverPublicURL})`,
    //backgroundRepeat:"no-repeat",
    //backgroundSize: "contain",
    ".card-cta":{
      ">div":{
        alignItems: "flex-start",
        gap: theme.spacing(1),

        "a": {
          marginTop: theme.spacing(1)
        }
      }
    },
    ".card-signature .icon": {
      height:"20px",
      width:"20px"
    },
    ".status-box": {
      height:"40px",
      width:"40px",

      left:"-20px",

      ".icon":{
        height:"19px",
        width:"19px"
      }

    },
    ".type":{
      fontSize:"1rem"
    },

    [`${OverlayStack}`]:{
      marginTop:"18px"
    }

  }

}));


export const DetailTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  lineHeight: 1.1875,
  marginBottom:"11px",
  maxWidth:"75%",

  "-webkit-box-orient": "vertical",
  "-webkit-line-clamp": "3",

  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",

  [theme.breakpoints.down("sm")]: {
    fontSize:"0.875rem",
    marginBottom:"10px",
    maxWidth:"100%"
  }
}));


export const TitleTypography = styled(Typography)(({ theme }) => ({
  ".primary": {
    color: theme.customColors?.exploreCardText
  },
  fontSize: "1.25rem",
  fontWeight:"700",
  lineHeight: "1.25rem",
  whiteSpace: "normal",
  wordWrap: "break-word",

  [theme.breakpoints.down("md")]: {
    maxWidth:"100%"
  }
}));

export const StyledBadgeHero = styled(Grid)<GridProps>(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundAccent,
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  color: theme.customColors.textPrimaryAlternative,
  display: "flex",
  fontSize: "16px",
  fontWeight:500,
  gap: "1rem",
  justifyContent: "center",
  left: "0",
  lineHeight: theme.spacing(3.75),
  padding: "5px 24px !important",
  // position: "absolute",
  width: "fit-content",

  [theme.breakpoints.down("sm")]: {
    fontSize: "0.875rem",
    padding: "8px 16px"
  }
}));

export const StyledIconLock = styled(Grid)(() => ({
  display: "flex",
  height:"fit-content",
  width: "fit-content",

  inset:"0",
  position: "absolute",

  margin:"auto"

}));


export const StatusBoxesStyle = styled("div")<{ isTablet: boolean }>(({ 
  isTablet
}) => ({
  opacity: 0,
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  flexWrap: "wrap",
  zIndex: 6,
  gap: "0.5rem",
  top: "50%",
  left: !isTablet ? "2.5rem" : "1rem",
  maxWidth: isTablet ? "21rem" : "unset",
  transition: "all 0.3s ease-out"
}));
